import React from 'react'
import { connect } from 'react-redux'
import { Box } from 'rebass/styled-components'
import Primary from '../components/nav/Primary'

const Header = () => {
    return (
        <Box variant="container" sx={{
            position: 'relative',
            zIndex: 999,
        }}>
            <Box variant="container" sx={{
                position: 'absolute',
                top: 0,
                width: '100%',
            }}>
                <Primary />
            </Box>
        </Box>
    )
}

export default connect()(Header)
